import gql from 'graphql-tag'

export const GET_PARTNER_TYPE = gql`
    query {
        PartnerType{      id
            name
            prefix
        }
    }
`
export const GET_ALL_APPLICATIONS = gql`
    query {
        Applications{      id
            PartnerType { name color prefix }
            User {name
                Organization { onlineOfflineType }
            }
            Stage{name}
            stageId
            partnerType
            name
            userName
            address
            mobile
            alternateNumber
            incorporateDate
            userBirthdate
            userAniversary
            email
            parentPartnerId
            updatedOn
            referralCode
        }
    }
`
export const GET_SINGLE_APPLICATION = gql`
    query Applications($applicationId: uuid!){
        Applications(where: {id: {_eq: $applicationId}}){
            id
            PartnerType { name color prefix }
            Stage { name }
            User {name}
            partnerType
            name
            userName
            address
            mobile
            alternateNumber
            incorporateDate
            userBirthdate
            userAniversary
            email
            gstin
            PAN
            bankDetails
            parentPartnerId
            ParentPartner{name}
            PreferedVP{name}
            SalesPersonId{name}
            updatedOn
            referralCode
        }
    }
`
export const GET_APPLICATION_HISTORY = gql`
    query ApplicationHistory($applicationId: uuid!){
        ApplicationHistory(where: {applicationId: {_eq: $applicationId}},order_by: {createdOn: desc}){
            id
            applicationId
            oldObject
            newObject
            difference
            eventType
            createdByUserName
            createdOn
        }
    }
`

export const GET_LEAGUE = gql`
    query ($parentPartnerId:uuid!){
        Organizations(where:{status:{_eq: "Active"},parentPartnerId:{_eq:$parentPartnerId}}){      id
            partnerType
            Application{userName}
            PartnerType {id name color prefix specialSchemeId }
            SchemePoints {id earnPoint eligiblePoint myTeamEligiblePoint myTeamEarnPoint schemeId}
            ParentPartner{name mobile email referralCode}
            PreferedVP{name mobile email}
            SalesPersonId{name mobile email}
            name
            status
            address
            applicationId
            mobile
            alternateNumber
            email
            PAN
            gstin
            incorporateDate
            partnerCode
            bankDetails
            products
            referralCode
            parentPartnerId
            createdOn
            updatedOn
        }
        Applications(where:{ _and:[{parentPartnerId: {_eq: $parentPartnerId}},{stageId:{_neq:"245eeacc-ceb2-4108-b281-1ce86a12cf02"}}]}){
            PartnerType { name }
            Stage { name }
            User {name}
            name
            ApplicationId
            id
            userName
            address
            mobile
            email
            gstin
            PAN
            bankDetails
            updatedOn
        }
    }
`

export const CHECK_DUPLICATE_APPLICATION_DETAILS = gql`
    query ($id:uuid,$mobile:String,$gstin:String,$PAN:String,$aadhaarNumber:String){
        Applications(where:{id:{_neq:$id},status:{_eq:"Active"},_or: [{mobile:{_eq:$mobile}},{gstin:{_eq:$gstin}},{PAN:{_eq:$PAN}},{aadhaarNumber:{_eq:$aadhaarNumber}}]}){
            id
        }
    }`
